import type { NodeApi } from 'react-arborist';

import type { SnippetTreeNodeData } from './types';

/**
 * Helper function to format a path based on type, with consistent directory handling.
 * Uses a simple rule: directories that don't end with "/" get one appended.
 */
export function formatPathForId(path: string, type: 'directory' | 'file'): string {
  if (type === 'directory' && !path.endsWith('/')) {
    return `${path}/`;
  }
  return path;
}

/**
 * Formats a snippet path based on the node type.
 * Directories get a trailing slash, files remain unchanged.
 */
export function formatSnippetPath(node: NodeApi<SnippetTreeNodeData>): string {
  return formatPathForId(node.data.path, node.data.type);
}

/**
 * Summarizes the snippet count for display purposes (pluralization, etc).
 */
export function summarizeSnippetCount(count: number): string {
  if (count === 1) {
    return '1 snippet';
  }
  return `${count} snippets`;
}

/**
 * Summarizes the path for display purposes. If the path is empty or
 * the root path, it displays "this project".
 */
export function summarizePath(path: string): string {
  if (!path || path === '/') {
    return 'this project';
  }

  return path;
}
